<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            collapseObject: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.contract.contract.item.accommodations.sites
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for(let i = 0; i < this.collapseObject[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();}, 10)
                }
            } else {
                for(let i = 0; i < this.collapseObject.length; i++) {
                    this.collapseObject[i].collapse = !(i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('site_' + obj.siteIndex).scrollIntoView();}, 10)
                }
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-accommodation">
        <div class="contract-form-accommodation__content">
            <div class="contract-form-accommodation__header">
                <div class="contract-form-accommodation__heading">
                    {{ $t('contract.form.accommodations.header.heading') }}
                </div>
            </div>
            <div class="contract-form-accommodation__body">
                <div class="contract-form-accommodation__sites">
                    <div v-for="(site, siteIndex) in sites" :id="'site_' + siteIndex" :key="'site_' + siteIndex" class="contract-form-accommodation__site">
                        <div :class="{'contract-form-accommodation__site-header--collapsed': collapseObject[siteIndex].collapse}" class="contract-form-accommodation__site-header" @click="collapse({siteIndex: siteIndex})">
                            {{ site.name }}
                        </div>
                        <div v-if="!collapseObject[siteIndex].collapse" class="contract-form-accommodation__accommodations">
                            <div v-for="(accommodation, accommodationIndex) in site.accommodations" :id="'accommodation_' + accommodationIndex" :key="'accommodation_' + accommodationIndex" class="contract-form-accommodation__accommodation">
                                <div :class="{'contract-form-accommodation__accommodation-header--collapsed': collapseObject[siteIndex].accommodations[accommodationIndex]}" class="contract-form-accommodation__accommodation-header" @click="collapse({siteIndex: siteIndex, accommodationIndex: accommodationIndex})">
                                    {{ accommodation.name }}
                                </div>
                                <div v-if="!collapseObject[siteIndex].accommodations[accommodationIndex]" class="contract-form-accommodation__accommodation">
                                    <div class="contract-form-accommodation__accommodation-info">
                                        <div class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.category}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.category') }}
                                            </div>
                                            <div class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.category }}</div>
                                        </div>
                                        <div class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.maxPersons}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.maxPersons') }}
                                            </div>
                                            <div v-if="accommodation.maxPersons" class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.maxPersons }}</div>
                                        </div>
                                        <div class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.maxAdults}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.maxAdults') }}
                                            </div>
                                            <div v-if="accommodation.maxAdults" class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.maxAdults }}</div>
                                        </div>
                                        <div class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.minFullPay}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.minFullPay') }}
                                            </div>
                                            <div v-if="accommodation.minFullPay" class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.minFullPay }}</div>
                                        </div>
                                        <div :title="$t('contract.form.accommodations.childrenAgesInfo')" class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.childrenAges}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.childrenAges') }}
                                            </div>
                                            <div v-if="accommodation.childrenAges" class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.childrenAges }}</div>
                                        </div>
                                        <div :title="$t('contract.form.accommodations.childOutsideAllowedInfo')" class="contract-form-accommodation__accommodation-info-element">
                                            <div :class="{'contract-form-accommodation__accommodation-info-element-label--inactive': !accommodation.childOutsideAllowed}" class="contract-form-accommodation__accommodation-info-element-label">
                                                {{ $t('contract.form.accommodations.childOutsideAllowed') }}
                                            </div>
                                            <div v-if="accommodation.childOutsideAllowed" class="contract-form-accommodation__accommodation-info-element-data">{{ accommodation.childOutsideAllowed }}</div>
                                        </div>
                                    </div>
                                    <div class="contract-form-accommodation__accommodation-images">
                                        <a v-for="(image, imageIndex) in accommodation.imagesS3" :href="image" :key="'image_' + imageIndex" target="_blank" class="contract-form-accommodation__accommodation-image-wrapper">
                                            <img :src="imageIndex" alt="" class="contract-form-accommodation__accommodation-image">
                                            <span class="contract-form-accommodation__accommodation-image-overlay">{{ $t('contract.form.accommodations.view') }}</span>
                                        </a>
                                    </div>
                                    <div class="contract-form-accommodation__accommodation-sub-groups">
                                        <div class="contract-form-accommodation__accommodation-sub-groups-header">
                                            {{ $t('contract.form.accommodations.subGroups.header') }}
                                        </div>
                                        <div v-for="(subGroup, subGroupIndex) in accommodation.subGroups" :key="'facilityGroup_' + subGroupIndex" class="contract-form-accommodation__accommodation-sub-group">
                                            <div class="contract-form-accommodation__accommodation-sub-group-header">
                                                {{ subGroup.name }}
                                            </div>
                                            <div class="contract-form-accommodation__accommodation-facilities">
                                                <div v-for="(facility, facilityIndex) in subGroup.facilities" :key="'facility_' + facilityIndex" class="contract-form-accommodation__accommodation-facility">
                                                    <div class="contract-form-accommodation__accommodation-facility-label">{{ facility.title }}</div>
                                                    <div class="contract-form-accommodation__accommodation-facility-data">{{ facility.value }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!sites.length" class="contract-form-accommodation__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">{{ $t('contract.form.accommodations.noContent') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormAccommodation/ContractFormAccommodation.vue